import { Component, computed, input, output, signal } from '@angular/core';
import { Button } from '@shared/components/button/button';
import { TestCaseResult } from '@shared/models/test-case';

@Component({
  selector: 'app-test-case-card',
  imports: [Button],
  templateUrl: './test-case-card.html',
})
export class TestCaseCard {
  isForVerify = input<boolean>(false);
  runTestClick = output<void>();
  submitClick = output<void>();
  testCaseDetails = input<TestCaseResult[]>();
  selectedId = signal<string | null>(null);
  selectedData = signal<TestCaseResult | null>(null);
  running = input(false);
  disabled = input<boolean>(false);
  readonly cache = computed(() => {
    const details = this.testCaseDetails() ?? [];
    return new Map(details.map(item => [item.testCaseId, item]));
  });
  readonly testCaseResultArray = computed(() =>
    Array.from(this.cache().values())
  );
  async handleRunTestClick() {
    this.runTestClick.emit();
    this.select(null);
  }
  async handleSubmitClick() {
    this.submitClick.emit();
    this.select(null);
  }

  select(id: string | null) {
    if (!id) {
      this.selectedId.set(null);
      this.selectedData.set(null);
      return;
    }

    this.selectedId.set(id);
    const found = this.cache().get(id) ?? null;
    this.selectedData.set(found);
  }
}
